export const ConditionalFormattingRestrictionSets = {
  InsertionOrderReport: [
    'ChangeAmount',
  ],
};
